import { Coverage } from "../models/coverage";
import { WHICHENSURE_TYPES } from "./personaldata";

export const RECOMMENDED_COVERAGES_LIST = ["NATURAL_DISASTER", "RENT_NO_RECEIVED"];

export const FIXED_COVERAGES_LIST = [];

export const MAIN_COVERAGE_CODE = "PRIME";

export const ASSISTANT_PACKAGE_CODE = "ASSISTS";

export const COVERAGES_CODES = {
    NATURAL_DISASTER: "NATURAL_DISASTER",
    CIVIL_RESPONSIBILITY: "CIVIL_RESPONSIBILITY",
    CRYSTAL_BREAK: "CRYSTAL_BREAK",
    THEFT_FIXED_INSTALLATION: "THEFT_FIXED_INSTALLATION",
    THEFT: "THEFT",
    THEFT_ESPECIAL: "THEFT_ESPECIAL",
    DISHONESTY: "DISHONESTY",
    DISAPPEAR: "DISAPPEAR",
    MEDICAL_INSURED: "MEDICAL_INSURED",
    TEMPORARY_SPENDS: "TEMPORARY_SPENDS",
    RENT_NO_RECEIVED: "RENT_NO_RECEIVED",
    PRIME: "PRIME",
    ASSISTS: "ASSISTS",
    VANDALISM: "VANDALISM",
    ROBBERY: "ROBBERY",
    ASSISTANCE_PACKAGE: "ASSISTANCE_PACKAGE",
};

export const COVERAGES_CODES_TRADUCTION = {
    NATURAL_DISASTER: "Terremoto y otros riesgos de la naturaleza",
    CIVIL_RESPONSIBILITY: "Daños a vecinos o terceros",
    CRYSTAL_BREAK: "Rotura accidental de ventanas o mamparas",
    THEFT_FIXED_INSTALLATION: "Robo de instalaciones fijas",
    THEFT: "Robo de bienes domésticos",
    THEFT_ESPECIAL: "Robo de bienes de alto valor",
    DISHONESTY: "Deshonestidad de trabajadores(as) del hogar",
    DISAPPEAR: "Hurto",
    MEDICAL_INSURED:
        "Reembolso de gastos médicos por accidentes de trabajadores del hogar",
    TEMPORARY_SPENDS:
        "Reembolso de alojamiento temporal, si no puedes habitar tu casa por un siniestro",
    RENT_NO_RECEIVED:
        "Alquiler no percibido si ya no puedes rentar tu vivienda a causa de un siniestro",
    PRIME: "Prima",
    ASSISTS: "Asistencias para el hogar",
    ROBBERY: "Robo de bienes domésticos",
    ASSISTANCE_PACKAGE: "Asistencias para el hogar",
};

export const COVERAGES_GROUPS = {
    ENSURE_CORES: {
        title: "¡Estas son las coberturas más pedidas!",
        subTitle: "",
        groupHasBox: false,
        itemsHasCheckbox: true,
        showEnsures: [
            WHICHENSURE_TYPES.ASSETS,
            WHICHENSURE_TYPES.HOUSING,
            WHICHENSURE_TYPES.HOUSING_ASSETS,
        ],
        items: [
            {
                order: 0,
                hasBg: true,
                code: COVERAGES_CODES.NATURAL_DISASTER,
                showEnsures: [
                    WHICHENSURE_TYPES.ASSETS,
                    WHICHENSURE_TYPES.HOUSING,
                    WHICHENSURE_TYPES.HOUSING_ASSETS,
                ],
            },
            {
                order: 1,
                hasBg: true,
                code: COVERAGES_CODES.ASSISTS,
                showEnsures: [
                    WHICHENSURE_TYPES.ASSETS,
                    WHICHENSURE_TYPES.HOUSING,
                    WHICHENSURE_TYPES.HOUSING_ASSETS,
                ],
            },
            {
                order: 2,
                hasBg: true,
                code: COVERAGES_CODES.CIVIL_RESPONSIBILITY,
                showEnsures: [
                    WHICHENSURE_TYPES.HOUSING_ASSETS,
                    WHICHENSURE_TYPES.HOUSING,
                ],
            },
            {
                order: 3,
                hasBg: true,
                code: COVERAGES_CODES.TEMPORARY_SPENDS,
                showEnsures: [
                    WHICHENSURE_TYPES.HOUSING_ASSETS,
                    WHICHENSURE_TYPES.HOUSING,
                ],
            },
        ],
    },
    ENSURE_THINGS: {
        title: "Asegura tus cosas o bienes",
        subTitle: "Valor total por todas estas coberturas es de: ",
        groupHasBox: true,
        itemsHasCheckbox: false,
        showEnsures: [WHICHENSURE_TYPES.ASSETS, WHICHENSURE_TYPES.HOUSING_ASSETS],
        items: [
            {
                order: 0,
                hasBg: false,
                code: COVERAGES_CODES.ROBBERY,
                showEnsures: [WHICHENSURE_TYPES.ASSETS, WHICHENSURE_TYPES.HOUSING_ASSETS],
            },
            {
                order: 1,
                hasBg: false,
                code: COVERAGES_CODES.THEFT_ESPECIAL,
                showEnsures: [WHICHENSURE_TYPES.ASSETS, WHICHENSURE_TYPES.HOUSING_ASSETS],
            },
            {
                order: 2,
                hasBg: false,
                code: COVERAGES_CODES.DISAPPEAR,
                showEnsures: [WHICHENSURE_TYPES.ASSETS, WHICHENSURE_TYPES.HOUSING_ASSETS],
            },
            {
                order: 3,
                hasBg: false,
                code: COVERAGES_CODES.DISHONESTY,
                showEnsures: [WHICHENSURE_TYPES.ASSETS, WHICHENSURE_TYPES.HOUSING_ASSETS],
            },
        ],
    },
    ENSURE_FIXED: {
        title: "Asegura tus instalaciones Fijas",
        subTitle: "Valor total por todas estas coberturas es de: ",
        groupHasBox: true,
        itemsHasCheckbox: false,
        showEnsures: [WHICHENSURE_TYPES.HOUSING, WHICHENSURE_TYPES.HOUSING_ASSETS],
        items: [
            {
                order: 0,
                hasBg: false,
                code: COVERAGES_CODES.CRYSTAL_BREAK,
                showEnsures: [
                    WHICHENSURE_TYPES.HOUSING,
                    WHICHENSURE_TYPES.HOUSING_ASSETS,
                ],
            },
            {
                order: 1,
                hasBg: false,
                code: COVERAGES_CODES.THEFT_FIXED_INSTALLATION,
                showEnsures: [
                    WHICHENSURE_TYPES.HOUSING,
                    WHICHENSURE_TYPES.HOUSING_ASSETS,
                ],
            },
        ],
    },
    ENSURE_OTHERS: {
        title: "Otras coberturas que puedes elegir",
        subTitle: "",
        groupHasBox: false,
        itemsHasCheckbox: true,
        showEnsures: [WHICHENSURE_TYPES.HOUSING, WHICHENSURE_TYPES.HOUSING_ASSETS],
        items: [
            {
                order: 0,
                hasBg: false,
                code: COVERAGES_CODES.RENT_NO_RECEIVED,
                showEnsures: [
                    WHICHENSURE_TYPES.HOUSING,
                    WHICHENSURE_TYPES.HOUSING_ASSETS,
                ],
            },
            {
                order: 1,
                hasBg: false,
                code: COVERAGES_CODES.MEDICAL_INSURED,
                showEnsures: [
                    WHICHENSURE_TYPES.HOUSING,
                    WHICHENSURE_TYPES.HOUSING_ASSETS,
                ],
            },
        ],
    },
};

// arrays to map all coverages

export const MAIN_COVERAGE_SUB_COVERAGES = [
    new Coverage({
        id: 1000,
        name:
            "Incendios y explosiones, filtraciones e inundaciones accidentales y daños por vandalismo",
        code: COVERAGES_CODES.VANDALISM,
    }),
];

export const ASSISTANT_PACKAGE_SUB_COVERAGES = [
    new Coverage({
        id: 8,
        name:
            "Servicios de cerrajería, gasfitería, electricidad y vidriería en caso de emergencia",
    }),
    new Coverage({ id: 9, name: "Ambulancia por accidente para el asegurado" }),
    new Coverage({ id: 10, name: "Chequeo preventivo del inmueble" }),
    new Coverage({ id: 10, name: "Orientación médica telefónica" }),
    new Coverage({ id: 11, name: "Limpieza del inmueble en caso de siniestro" }),
    new Coverage({ id: 12, name: "Asesoría legal por robo dentro del inmueble" }),
];
// end of comment

export const COVERAGES_ICONS = {
    NATURAL_DISASTER: "coverage-earthquake",
    CIVIL_RESPONSIBILITY: "coverage-third-parties",
    CRYSTAL_BREAK: "coverage-crystal-break",
    THEFT_FIXED_INSTALLATION: "coverage-theft-fixed",
    MEDICAL_INSURED: "coverage-ambulance",
    RENT_NO_RECEIVED: "coverage-missing-rent",
    TEMPORARY_SPENDS: "coverage-temporary-spends",
    ROBBERY: "coverage-thefts-domestic",
    DISAPPEAR: "coverage-thefts",
    THEFT_ESPECIAL: "coverage-thefts-special",
    DISHONESTY: "coverage-dishonesty",
    ASSISTS: "coverage-assists",
    ASSISTANCE_PACKAGE: "coverage-assists",
};

export const COVERAGES_ORDER = {
    NATURAL_DISASTER: 1,
    CIVIL_RESPONSIBILITY: 2,
    CRYSTAL_BREAK: 3,
    THEFT_FIXED_INSTALLATION: 4,
    ROBBERY: 5,
    THEFT: 6,
    DISAPPEAR: 7,
    THEFT_ESPECIAL: 8,
    DISHONESTY: 9,
    MEDICAL_INSURED: 10,
    TEMPORARY_SPENDS: 11,
    RENT_NO_RECEIVED: 12,
};

export const COVERAGES_BY_ENSURED_TYPE = {
    [WHICHENSURE_TYPES.ASSETS]: [
        COVERAGES_CODES.NATURAL_DISASTER,
        COVERAGES_CODES.ASSISTS,
        COVERAGES_CODES.ROBBERY,
        COVERAGES_CODES.THEFT_ESPECIAL,
        COVERAGES_CODES.DISAPPEAR,
        COVERAGES_CODES.DISHONESTY,
        COVERAGES_CODES.RENT_NO_RECEIVED,
        COVERAGES_CODES.MEDICAL_INSURED,
    ],
    [WHICHENSURE_TYPES.HOUSING]: [
        COVERAGES_CODES.NATURAL_DISASTER,
        COVERAGES_CODES.ASSISTS,
        COVERAGES_CODES.CIVIL_RESPONSIBILITY,
        COVERAGES_CODES.CRYSTAL_BREAK,
        COVERAGES_CODES.THEFT_FIXED_INSTALLATION,
        COVERAGES_CODES.MEDICAL_INSURED,
        COVERAGES_CODES.TEMPORARY_SPENDS,
        COVERAGES_CODES.RENT_NO_RECEIVED,
    ],
};

export const COVERAGES_DEPENDENCY = [
    {
        mainCoverage: COVERAGES_CODES.ROBBERY,
        whichEnsure: WHICHENSURE_TYPES.ASSETS,
        dependentCoverages: [
            COVERAGES_CODES.DISAPPEAR,
            COVERAGES_CODES.THEFT_ESPECIAL,
            COVERAGES_CODES.DISHONESTY,
        ],
    },
    {
        mainCoverage: COVERAGES_CODES.ROBBERY,
        whichEnsure: WHICHENSURE_TYPES.HOUSING_ASSETS,
        dependentCoverages: [
            COVERAGES_CODES.DISAPPEAR,
            COVERAGES_CODES.THEFT_ESPECIAL,
            COVERAGES_CODES.DISHONESTY,
        ],
    },
];
